var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 4C12.4142 4 12.75 4.33579 12.75 4.75V6.25H14.5C16.0188 6.25 17.25 7.48122 17.25 9C17.25 9.41421 16.9142 9.75 16.5 9.75C16.0858 9.75 15.75 9.41421 15.75 9C15.75 8.30964 15.1904 7.75 14.5 7.75H10C9.0335 7.75 8.25 8.5335 8.25 9.5C8.25 10.4665 9.0335 11.25 10 11.25H14C15.7949 11.25 17.25 12.7051 17.25 14.5C17.25 16.2949 15.7949 17.75 14 17.75H12.75V19.25C12.75 19.6642 12.4142 20 12 20C11.5858 20 11.25 19.6642 11.25 19.25V17.75H9.5C7.98122 17.75 6.75 16.5188 6.75 15C6.75 14.5858 7.08579 14.25 7.5 14.25C7.91421 14.25 8.25 14.5858 8.25 15C8.25 15.6904 8.80964 16.25 9.5 16.25H14C14.9665 16.25 15.75 15.4665 15.75 14.5C15.75 13.5335 14.9665 12.75 14 12.75H10C8.20507 12.75 6.75 11.2949 6.75 9.5C6.75 7.70507 8.20507 6.25 10 6.25H11.25V4.75C11.25 4.33579 11.5858 4 12 4Z",
    fill: "#808085"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/usd.89b28dce.svg";
export { ForwardRef as ReactComponent };